import { createSlice, createAction } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
const initialState = {
	// isLogin: false,
	// account: "",
	// info: {
	// 	user_name: "",
	// 	unit_name: "",
	// 	county: "",
	// 	township: "",
	// 	is_dealer: true,
	// },
	// token: "",
	// refreshToken: "",
	info:null,
	identities:null,
	OrderSuccess: null,
	Firm: ''
};
// JSON.parse(await storage.getItem("persist:tms-tada-state"))?.Firm || ''
export const logout = createAction("logout");
export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		// rememberAccount: (state, action) => {
		// 	state.account = action.payload;
		// },
		// updateIslogin: (state, action) => {
		// 	state.isLogin = action.payload;
		// },
		updateIdentities:(state, action) => {
			state.identities = action.payload;
		},
		updateInfo: (state, action) => {
			state.info = action.payload;
		},
		ClearUser:async (state, action) =>{
			updateIdentities(null)
			updateInfo(null)
			addOrderSuccess(null)
			// console.log(d)
			// console.log(storage)

			// storage.removeItem('persist:tms-tada-state')
		},
		addOrderSuccess:(state,action)=>{
			state.OrderSuccess = action.payload
		},
		
		// updateToken: (state, action) => {
		// 	state.token = action.payload;
		// },
		// updateRefreshToken: (state, action) => {
		// 	state.refreshToken = action.payload;
		// },
	},
	// extraReducers: (builder) => {
	// 	builder.addCase(logout, (state) => {
	// 		return { ...initialState, account: state.account };
	// 	});
	// },
});

export const { updateIdentities , updateInfo,ClearUser,addOrderSuccess,updateFirm } = userSlice.actions; //給React組件個別使用
export default userSlice.reducer; //給store.js使用
